export default function PreviewFallback({ message }) {  
  return (
    <div className="preview__main">
      <p className="preview__caption">{message}</p>
    </div>
  )
}
